function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "b4d6f2bc-ae5e-476c-81ed-6eb215cdf2b8",
  x1: 585.6,
  y1: 663,
  x2: 585.6,
  y2: 249,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "9c7f1c1e-55bc-40cd-85e2-0f597ed8a8ed",
  x1: 266.19,
  y1: 487.11,
  x2: 266.19,
  y2: 486.89,
  xlinkHref: "#b4d6f2bc-ae5e-476c-81ed-6eb215cdf2b8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "9ac4e148-2e83-4d81-ad56-620a328cd147",
  x1: 252.55,
  y1: 605,
  x2: 252.55,
  y2: 271,
  xlinkHref: "#b4d6f2bc-ae5e-476c-81ed-6eb215cdf2b8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2bd42fb4-2e8b-436b-a616-1dc6bfdc374d",
  x1: 852.66,
  y1: 602,
  x2: 852.66,
  y2: 195,
  xlinkHref: "#b4d6f2bc-ae5e-476c-81ed-6eb215cdf2b8"
}));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "celebration");

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 95.13,
  cy: 66.03,
  r: 46.49,
  fill: "#ffffff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M214.55,279.91C234.07,324,209.17,374.77,179.86,413c-9.81,12.82-20.64,26.26-22,42.34-1.64,19.67,11.68,37.75,27.48,49.57,28.82,21.54,68.18,28.2,102.48,17.33,29.64-9.39,54.56-30.6,84.46-39.15,50-14.32,103,9.42,145.82,39C548.41,543,580.87,568.48,617.41,564c25.71-3.15,47.53-21.2,62.34-42.45,7.15-10.26,13.37-21.76,23.78-28.68,6.19-4.12,13.46-6.3,20.73-7.86,66.39-14.19,136.85,20.44,202.36,2.63,44.25-12,79.53-47,101.47-87.27s32.18-85.74,40.71-130.79c6.06-32,11.09-66.57-2.84-96-14.74-31.16-48.86-50.05-83.15-53.59S914.13,126.22,882.54,140c-39.47,17.26-78.16,41.42-121.24,41.5-29.34.06-57.32-11.2-85.37-19.79-46.9-14.35-95.67-21.48-144.27-28.06-46.53-6.3-93.52-12.16-140.33-8.44-33.12,2.63-62.37,15.29-94.51,21.15-20.95,3.82-42,1-62.56,7.4-25.32,7.92-51.36,26.27-52.76,55.17C180.18,236.44,204.2,256.52,214.55,279.91Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff",
  opacity: 0.1
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M727,319.17c-4.27-11.13-15.28-37.29-22.53-32.1-9.16,6.56,9.16,35.54,9.16,35.54.52,5.32-9.78,16.39-15.3,21.91,0-.44,0-.69,0-.69a2.4,2.4,0,0,1-.24.6l-.46-.25a3,3,0,0,1-.65,1.19c0-.75-.05-1.19-.05-1.19-1.06,4.49-19.56,10.18-19.56,10.18s-.5,0-1.36,0c-5.14,0-18.52-1.16-24.72-11.08a54.86,54.86,0,0,0-12.13-14.15,10.33,10.33,0,0,0-5.75-2.18c-17.13-1.1-31-9.77-33.77-11.62l-.51-.35-.11.32c-.65-.93-1.28-1.92-1.87-2.94l0,0-.3-.55a25.12,25.12,0,0,0,13.85-22.34c0-.17,0-.35,0-.52a17.11,17.11,0,0,0,2.3-8.57v-3l3.91-3.48c1.79-1.59,3.64-3.27,4.55-5.46a6.47,6.47,0,0,0,.48-2.8,4.85,4.85,0,0,0-1.84-4.34c-3-2.07-8,0-10.17-2.88-1-1.3-.82-3.07-1.31-4.6-1-3.11-4.6-4.79-7.93-4.84s-6.52,1.16-9.72,2.07a57.07,57.07,0,0,1-20.7,1.94,13.52,13.52,0,0,0-5.67.2,7.81,7.81,0,0,0-4.6,5.35,12.57,12.57,0,0,0-.44,2.74,17.24,17.24,0,0,0-4.34,11.41v7.69a17.23,17.23,0,0,0,4.15,11.19,25,25,0,0,0,10.47,18.24q0,.3,0,.61l.13.08a41.35,41.35,0,0,1-1.1,7.07l0-.51s-14,7.45-29,7.63h-1.65a11.17,11.17,0,0,0-8,3c-4.44,4.18-12.22,10.79-17,10.79-1,0-26.24,4.93-30.42,5.75l-7.81-7.65-.24.45-.46-.45a19,19,0,0,0-2.54.37c-4-4.74-12-15.76-13.85-30.55,0,0,17.27-19.67,10.92-38-5.42-15.62-20.35,17.86-24.59,27.95a8.06,8.06,0,0,0-.26,5.55L458,347.12a21.21,21.21,0,0,0-1.11,11l-.16,0,10.22,13.11s7.69,3.28,19.72,3.22a68.94,68.94,0,0,0,25.74-4.94h2.37l-.45.17H526.5l7.74,23.41c-.26,2.13-4,31.86-7,38.51a16.71,16.71,0,0,0-1.18,7,53.44,53.44,0,0,0,2.23,13.55l6.78-.25-.26.53c-5.74,11.77-15.33,32.74-21,52.34l-9.87,20,7.4,89.7h0l.3,0h0l.57.09h0c.8.12,2,.3,3.58.5l-.58,1-16.31,27s-11.63,23.81,14.1,19.32c0,0,9.51-2.76,13.39-19l16.92-15.87s.79-10.54-4-14.75c-.3-4.87-1.06-19.09.11-22.51,1.41-4.14-6-51.75-6-51.75s26.78-55.55,43-56.93a8.89,8.89,0,0,1,3.51.46c13.33,4.34,29.48,36.57,34.23,46.6l0,0,.22.46,0,.09.18.39,0,.11.16.34,0,.09.14.31,0,.07.12.25,0,.1.09.19,0,.08.06.14,0,.08,0,.09h0l.05.12,2.11,62.45h0l0,0h0l.21.11h0l.1,0-.18,1.29-.92,6.45s11.63,24.5,10.92,27.6,7.75,15.53,19.73,12.08S652,618.62,652,618.62l-11.54-23.78-.51-1.06a22.68,22.68,0,0,0,3.24-2.41s-3.52-25.53,0-31.05,4.58-30.71,4.58-30.71-2.47-17.25-6.7-24.84l-17.72-63.25c5.31,4.94,9.44,6.87,12.89,6.74h.57a8.61,8.61,0,0,0,4.34-1.08,12.23,12.23,0,0,0,2-1.41,3.16,3.16,0,0,0,.33-.33l0,0c4.93-4.14-5.64-20.36-11.63-30-5.77-9.3,2.18-34.57,2.78-36.45a9.54,9.54,0,0,1,1.71-1,10.55,10.55,0,0,1,3.92-.85c5.74.2,12.8,3.5,21.54,5.16a101.62,101.62,0,0,0,18.39,1.43h.36c2.45,0,4.67-.05,6.47-.12a10.93,10.93,0,0,0,4.7-1.27h0a14.19,14.19,0,0,0,3.34-2.7l15.34-17.33-.4.19a8.62,8.62,0,0,0,0-6.1l16.21-28A10.65,10.65,0,0,0,727,319.17Z",
  transform: "translate(-125.1 -119.24)",
  fill: "url(#b4d6f2bc-ae5e-476c-81ed-6eb215cdf2b8)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M544.88,625.14l-16.33,15.65c-3.74,16-12.93,18.71-12.93,18.71-24.83,4.42-13.61-19-13.61-19l15.75-26.65,1.94-3.29s11.23-3.4,18.71-1.36a6.4,6.4,0,0,1,2.55,1.38C545.65,614.65,544.88,625.14,544.88,625.14Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#444176"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M645.57,639.09c-11.57,3.4-19.73-8.84-19-11.91S616,600,616,600l.88-6.36.82-5.89,19,1.36,1.79,3.76,11.14,23.45S657.14,635.69,645.57,639.09Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#444176"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M541.14,613.24c-1.79,3.07-16.3,1.52-23.37.56l1.94-3.29s11.23-3.4,18.71-1.36a6.4,6.4,0,0,1,2.55,1.38C541.07,612.19,541.14,613.24,541.14,613.24Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M638.51,592.85c-9.73,6.48-20.09,1.58-21.65.77l.82-5.89,19,1.36Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M641.15,558.81c-3.4,5.44,0,30.62,0,30.62-11.23,10.21-24.49,2.72-24.49,2.72l-2-61.57s-22.11-50.69-37.76-49.33-41.5,56.13-41.5,56.13,7.14,46.94,5.78,51,0,23.81,0,23.81c-2.38,4.08-27.21,0-27.21,0l-7.14-88.45L516.31,504c5.45-19.32,14.71-40,20.25-51.6,2.75-5.77,4.59-9.29,4.59-9.29l18.1-3.77L618,427.16,639.11,504c4.08,7.48,6.46,24.49,6.46,24.49S644.55,553.37,641.15,558.81Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#565387"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M622.1,592.15l-2-61.57s-22.11-50.69-37.76-49.33a8.52,8.52,0,0,0-2.05.46c15.26,5.07,34.37,48.87,34.37,48.87l2,61.57a24,24,0,0,0,13.53,2.47A24.07,24.07,0,0,1,622.1,592.15Z",
  transform: "translate(-125.1 -119.24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M519.37,612.22l-7.14-88.45L521.75,504c5.45-19.32,14.71-40,20.25-51.6,2.75-5.77,4.59-9.29,4.59-9.29l18.1-3.77,53.63-11.15-.29-1.07-58.78,12.22-18.1,3.77s-1.84,3.52-4.59,9.29C531,464,521.76,484.72,516.31,504l-9.52,19.73,7.14,88.45s13.56,2.23,21.6,1.74A160.66,160.66,0,0,1,519.37,612.22Z",
  transform: "translate(-125.1 -119.24)"
}));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M478,338.21s-19.39,1-16.67,21.43l5.44.68,8.16-8.84,4.08-7.48v-1.7Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ced2df"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M478,338.21s-19.39,1-16.67,21.43l5.44.68,8.16-8.84,4.08-7.48v-1.7Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M693.71,345.69s16,8.5,11.91,18.37l-5.1,2-6.8-3.74-1-8.84.68-6.12Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ced2df"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M693.71,345.69s16,8.5,11.91,18.37l-5.1,2-6.8-3.74-1-8.84.68-6.12Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 431.18,
  y: 138.68,
  width: 55.79,
  height: 42.18,
  rx: 21.09,
  ry: 21.09,
  fill: "#88455e"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M477.87,341.1l-11.91,19-1-3.38L448.78,304a8.11,8.11,0,0,1,.25-5.47c4.09-9.94,18.51-43,23.74-27.55,6.12,18-10.55,37.42-10.55,37.42,1.9,15.76,10.75,27.18,14.23,31.14C477.33,340.57,477.87,341.1,477.87,341.1Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ec8c9c"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M691.16,349.26s18.71-17.69,18-24.83c0,0-17.69-28.57-8.84-35,7-5.12,17.63,20.68,21.75,31.65a10.7,10.7,0,0,1-.71,9L699,369.67Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ec8c9c"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M570.05,299.94s3.4,21.77-6.46,29.94S591.83,338,591.83,338l13.61-12.59s-15.65-14.63-10.89-25.51Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ec8c9c"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M569.37,324.77s14.63,10.89,29.25-1.36l23.81,49.33-1.36,60.21s-49.33,25.51-69.74,9.87-3.4-23.81-3.4-23.81l-4.76-46.26,5.1-29.94s9.18-14.29,9.87-14.29S569.37,324.77,569.37,324.77Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M569.37,324.09S584,335,598.63,322.73l23.81,49.33-1.36,60.21s-49.33,25.51-69.74,9.87-3.4-23.81-3.4-23.81l-4.76-46.26,5.1-29.94s9.18-14.29,9.87-14.29S569.37,324.09,569.37,324.09Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ebf1f6"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M569.37,319s-13.87,7.9-28.93,7.51a10.66,10.66,0,0,0-7.69,2.94c-4.29,4.12-11.8,10.64-16.45,10.64-1,0-29.94,5.78-29.94,5.78l-7.65-7.65s-11.4,22.28-16.84,21.26l9.87,12.93s18.71,8.16,43.2-1.7h14.29l7.48,23.13s-3.74,31.3-6.8,38.1,1,20.07,1,20.07l26.87-1s1.36-13.27,3.4-15-7.14-60.21-7.14-60.21-6.12-33,16.33-44.9Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M559.24,439.38a88.81,88.81,0,0,0-2.11,12.27l-20.57.78c2.75-5.77,4.59-9.29,4.59-9.29Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M477.87,341.1l-11.91,19-1-3.38c4.37-4.34,9.49-13.41,11.53-17.19C477.33,340.57,477.87,341.1,477.87,341.1Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M569.37,319s-14.56,7.9-29.61,7.51a10.66,10.66,0,0,0-7.69,2.94c-4.29,4.12-11.8,10.64-16.45,10.64-1,0-29.94,5.78-29.94,5.78L478,338.21s-11.4,22.28-16.84,21.26l9.87,12.93s18.71,8.16,43.2-1.7h14.29L536,393.82s-3.74,31.3-6.8,38.1,1,20.07,1,20.07l26.87-1s1.36-13.27,3.4-15-7.14-60.21-7.14-60.21-6.12-33,16.33-44.9Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ced2df"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M598.63,316.94s13.88,10.58,32.41,11.8a9.85,9.85,0,0,1,5.55,2.15,53.72,53.72,0,0,1,11.71,14c7.48,12.25,25.85,10.89,25.85,10.89s17.86-5.61,18.88-10c0,0,.51,24,11.74,18.2L690,381a10.42,10.42,0,0,1-7.45,3.59c-5.55.22-15.19.29-23.33-1.29-12.25-2.38-21.09-8.16-27.55-3.06,0,0-8.5,26.53-2.72,36.06s16,25.51,11.23,29.6-10.55,3.74-20.07-6.12-10.55-26.53-10.55-26.53l2.38-42.86s-9.18-32.32-18-38.78Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M706.12,363.55l-14.81,17.09a10.41,10.41,0,0,1-3.57,2.66h0a10.37,10.37,0,0,1-3.86.91c-5.55.23-15.19.3-23.33-1.29-11.46-2.23-19.94-7.43-26.28-3.92a9.3,9.3,0,0,0-1.28.85s-8.5,26.53-2.72,36.06,16,25.51,11.23,29.6a11,11,0,0,1-2.66,1.73c-4.28,1.93-9.59.26-17.41-7.85-9.52-9.87-10.55-26.53-10.55-26.53L613.26,370s-9.18-32.32-18-38.78l3.89-13.95c2.68,1.82,16.06,10.37,32.6,11.46a9.85,9.85,0,0,1,5.55,2.15,53.76,53.76,0,0,1,11.71,14c7.48,12.25,25.85,10.89,25.85,10.89a99.27,99.27,0,0,0,12.87-5.12l0,0c2.61-1.28,4.91-2.68,6-4a3,3,0,0,0,.65-1.2S694.9,369.33,706.12,363.55Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M705.44,363.89,690.64,381a10.41,10.41,0,0,1-2.88,2.32h0a10.38,10.38,0,0,1-4.54,1.25c-5.55.23-15.19.3-23.33-1.29-11.05-2.15-19.34-7.07-25.59-4.26a9.25,9.25,0,0,0-2,1.19s-8.5,26.53-2.72,36.06,16,25.51,11.23,29.6a11.8,11.8,0,0,1-2,1.39c-4.4,2.43-9.84,1-18.09-7.51-9.52-9.87-10.55-26.53-10.55-26.53l2.38-42.86s-9.18-32.32-18-38.78l4.08-14.63.49.34c2.68,1.82,16.06,10.37,32.6,11.46a9.85,9.85,0,0,1,5.55,2.15,53.76,53.76,0,0,1,11.71,14c7.48,12.25,25.85,10.89,25.85,10.89a99.27,99.27,0,0,0,12.87-5.12l0,0c3.09-1.58,5.61-3.31,6-4.89,0,0,0,.31,0,.86C694,350.77,695.5,369,705.44,363.89Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ced2df"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M594.85,300.45h-25a61.18,61.18,0,0,1,.47,12,25.7,25.7,0,0,0,26.42,1.9C594.34,309.91,592.88,304.87,594.85,300.45Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref31 = /*#__PURE__*/React.createElement("circle", {
  cx: 459.92,
  cy: 172.53,
  r: 24.83,
  fill: "#ec8c9c"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M579.86,287.35c2.77-.33,5.54-1.31,8.27-.76,2.48.5,4.59,2.21,7.07,2.73,4.78,1,9.22-2.52,12.83-5.8l7.8-7.1c1.73-1.57,3.51-3.22,4.4-5.38s.58-5-1.32-6.36c-2.85-2-7.76,0-9.82-2.84-.93-1.28-.79-3-1.27-4.53-1-3.06-4.44-4.73-7.66-4.77s-6.3,1.14-9.38,2a54,54,0,0,1-20,1.91,12.78,12.78,0,0,0-5.47.19,7.65,7.65,0,0,0-4.44,5.27c-1.54,5.44,1.09,14.21,3.73,19.08S574.59,288,579.86,287.35Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M579.86,286.67c2.77-.33,5.54-1.31,8.27-.76,2.48.5,4.59,2.21,7.07,2.73,4.78,1,9.22-2.52,12.83-5.8l7.8-7.1c1.73-1.57,3.51-3.22,4.4-5.38s.58-5-1.32-6.36c-2.85-2-7.76,0-9.82-2.84-.93-1.28-.79-3-1.27-4.53-1-3.06-4.44-4.73-7.66-4.77s-6.3,1.14-9.38,2a54,54,0,0,1-20,1.91,12.78,12.78,0,0,0-5.47.19,7.65,7.65,0,0,0-4.44,5.27c-1.54,5.44,1.09,14.21,3.73,19.08S574.59,287.27,579.86,286.67Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#88455e"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M536.55,394s5.44.68,8.16,4.08,7.48,4.42,7.48,4.42",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M487.56,349.09S492,359,489.26,360s-1.7,8.16-1.7,8.16",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref36 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M489.09,345.69S518,339.91,519,339.91c4.66,0,12.16-6.52,16.45-10.64a10.5,10.5,0,0,1,4.66-2.59h-.37a10.66,10.66,0,0,0-7.69,2.94c-4.29,4.12-11.8,10.64-16.45,10.64-.81,0-19.31,3.67-26.82,5.16Z",
  transform: "translate(-125.1 -119.24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M569.41,320.43l0-1.27a72.18,72.18,0,0,1-22.16,7.09A68.48,68.48,0,0,0,569.41,320.43Z",
  transform: "translate(-125.1 -119.24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M533.66,451.82s-4.08-13.27-1-20.07,6.8-38.1,6.8-38.1L532,370.52H517.67l-.87.34h11.75L536,394s-3.74,31.3-6.8,38.1,1,20.07,1,20.07l26.87-1,0-.21Z",
  transform: "translate(-125.1 -119.24)"
}));

var _ref37 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M641.15,440.43a11.8,11.8,0,0,1-2,1.39c-4.4,2.43-9.84,1-18.09-7.51-7.56-7.83-9.76-20-10.35-24.61l-.2,3.52s1,16.67,10.55,26.53c8.25,8.54,13.69,9.94,18.09,7.51a11.8,11.8,0,0,0,2-1.39c1.43-1.23,1.51-3.54.76-6.42A3.15,3.15,0,0,1,641.15,440.43Z",
  transform: "translate(-125.1 -119.24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M700.63,364.4,691,375.53a10.41,10.41,0,0,1-2.88,2.32h0a10.38,10.38,0,0,1-4.54,1.25c-5.55.23-15.19.3-23.33-1.29-11.05-2.15-19.34-7.07-25.59-4.26a9.25,9.25,0,0,0-2,1.19s-5.49,17.14-4.65,28.81c.65-10.91,4.65-23.37,4.65-23.37a9.25,9.25,0,0,1,2-1.19c6.26-2.81,14.54,2.11,25.59,4.26,8.14,1.58,17.77,1.51,23.33,1.29a10.38,10.38,0,0,0,4.54-1.25h0A10.41,10.41,0,0,0,691,381l14.81-17.09A5.83,5.83,0,0,1,700.63,364.4Z",
  transform: "translate(-125.1 -119.24)"
}));

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M265.74,486.89a.77.77,0,0,0,.91.12A3.1,3.1,0,0,1,265.74,486.89Z",
  transform: "translate(-125.1 -119.24)",
  fill: "url(#9c7f1c1e-55bc-40cd-85e2-0f597ed8a8ed)"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M367.65,321.24c-1.8-.52-4.37-1.37-7.46-2.45a39.12,39.12,0,0,0,6.91-13.92l-.26.1c.09-.31.18-.61.26-.93-5.93,2.41-12.49-1.67-16.67-6.91s-7-11.74-11.58-16.56a53,53,0,0,0-6.14-5.29c-1.35-1-2.8-2.13-4.45-2.18-2.67-.08-4.76,2.54-7.33,3.31a10,10,0,0,1-5.11-.19c-6.63-1.52-13-4.33-19.77-5.07a23.17,23.17,0,0,0-10.73,1.21c-3.4,1.29-4.95,3.86-7.7,5.92-3,2.21-8.86,2.16-12.35,2.55a88.5,88.5,0,0,1-12.76.53,29.87,29.87,0,0,0-7.34.27c-5.07,1.11-9.14,5.14-12.94,9a6.67,6.67,0,0,0-2.14,3.35,4.23,4.23,0,0,0,0,1.11,7.21,7.21,0,0,0,.51,2.95,39,39,0,0,0,4.91,9.77c1.55,2.22,3.36,4.31,4.24,6.94a13.47,13.47,0,0,1,.65,4,29.09,29.09,0,0,1-.45,4.3,54,54,0,0,1-3.29,11.45,20.8,20.8,0,0,0-1.92,6,9.56,9.56,0,0,0,0,1.28c-.25,6.6,6.41,11.35,7.7,17.91a10.7,10.7,0,0,1,.19,1.65c-.14,4.09-2.47,8.09-5.91,9.68.3.12.61.22.92.32a8.34,8.34,0,0,1-.92.5c.63.24,1.27.45,1.92.62a44.6,44.6,0,0,0-9.71,12C217.36,406,139,448.19,139,448.19l1.16.66-.94.61c-6.78,4.51-22.69,17.66-8.31,34.29,0,0,11.23-17.72,19.1-25.27.35-.34.7-.65,1-.94a2.3,2.3,0,0,1,.3,1.82l51.52-28.95s18.31-12.82,23.42-15.71a42.15,42.15,0,0,1,11.61-5l-.6.25a23.52,23.52,0,0,1,5.91-.84c9.12.14,19,6.82,22.25,33.27,4.36,35.42,2.34,41.81.94,42.68a2.57,2.57,0,0,1-.51-.09.87.87,0,0,0,.14.1,2.68,2.68,0,0,1-.56-.1.8.8,0,0,0,.76.18.71.71,0,0,0,.57-.07h0a5.92,5.92,0,0,0,.69,0q0,.49-.07,1c-.07,0-.41.19,0,.21h0c-.11,2-.1,4.17,0,6.44-4.53.25-9.06.52-13,.76l.35-1.87.16-.84c3.48-.28,6.78-1.3,7.17-4.12.85-6.2-7.66-9.51-14.9-9.92s-50.66,2.48-50.66,2.48-6.51,8.43,14.14,11q.92.48,1.91,1c8.09,4.61,19.06,13.1,24.32,17.28l.73.58L235.24,511c12.77,2.89,25.12,51.69,31.93,74s21.71,21.5,34.06,18.19c11.57-3.1,13-36.7,13.19-40.92v-.43L335,587.26l1.56,1.93q.9.47,1.78.88c15.58,7.41,32.79-6.8,27.9-23-4.95-16.33-12.63-40.48-17.75-50.69-4.29-8.55-9.83-22.75-13.19-31.64a10.68,10.68,0,0,0,1.27-.61s-.08-.4-.21-1.13l.21-.11s-5-25.72-5.22-44q0-.48,0-1c0-.2,0-.4,0-.59,3.72-.85,6.08-1.18,6.08-1.18l.07-.8-.43.09,2.07-23.69s7.6-16.17,1.78-22.9a14.14,14.14,0,0,1-3.41-7c-1-6.19,0-16.52,13.55-25.1,20.86-13.23,29-24,29-24S380.42,325,367.65,321.24Zm-41.43,16.44V326.73c3.87-.19,7.82.26,11.71,0a29.63,29.63,0,0,0,5.65-.95l.94.65A103,103,0,0,1,326.22,337.68ZM267.07,509.32c1.53,1.06,3.07,2.16,4.58,3.27.94,5.4,1.77,9.21,1.83,9.48A74.86,74.86,0,0,0,267.07,509.32Z",
  transform: "translate(-125.1 -119.24)",
  fill: "url(#9ac4e148-2e83-4d81-ad56-620a328cd147)"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M300.13,500.32l-.9,4.89-.69,3.74-1.26,6.84-12.22,8.55s-1.1-.94-2.92-2.43c-5-4.12-15.53-12.48-23.26-17a26,26,0,0,0-6.39-2.95Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffbdc6"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M300.13,500.32l-.9,4.89a38,38,0,0,1-8.06-.41l-28.51.41c-1.35-.08-2.61-.19-3.79-.31a26,26,0,0,0-6.39-2.95Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M291.17,504s14.26,2.44,15.07-3.67S298.91,491,292,490.54,243.52,493,243.52,493s-7.33,9.77,19.14,11.4Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#7679b4"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M300.13,500.32l-.9,4.89-.69,3.74-1.26,6.84-12.22,8.55s-1.1-.94-2.92-2.43c-5-4.12-15.53-12.48-23.26-17a26,26,0,0,0-6.39-2.95Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M300.13,500.32l-.9,4.89a38,38,0,0,1-8.06-.41l-28.51.41c-1.35-.08-2.61-.19-3.79-.31a26,26,0,0,0-6.39-2.95Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M291.17,504s14.26,2.44,15.07-3.67S298.91,491,292,490.54,243.52,493,243.52,493s-7.33,9.77,19.14,11.4Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref46 = /*#__PURE__*/React.createElement("rect", {
  x: 122.69,
  y: 183.95,
  width: 74.53,
  height: 88.38,
  fill: "#a66477"
});

var _ref47 = /*#__PURE__*/React.createElement("rect", {
  x: 122.69,
  y: 183.95,
  width: 74.53,
  height: 88.38,
  opacity: 0.1
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M160.43,454.5c-1.23.31-2.79,1.49-4.54,3.21-7.53,7.44-18.27,24.89-18.27,24.89-13.76-16.38,1.47-29.33,8-33.78,1.58-1.08,2.64-1.66,2.64-1.66Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffbdc6"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M299.32,331.09s3.67,25.66,16.29,31.77-16.29,17.51-16.29,17.51l-39.51-14.66s22.4-7.33,17.92-28.92Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffbdc6"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M257,485.45l-.9,4.89-.69,3.74-1.26,6.84-12.22,8.55s-1.1-.94-2.92-2.43c-5-4.12-15.53-12.48-23.26-17a26,26,0,0,0-6.39-2.95Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffbdc6"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M257,485.45l-.9,4.89a38,38,0,0,1-8.06-.41l-28.51.41c-1.35-.08-2.61-.19-3.79-.31a26,26,0,0,0-6.39-2.95Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M248,489.12s14.26,2.44,15.07-3.67-7.33-9.37-14.26-9.77-48.47,2.44-48.47,2.44-7.33,9.77,19.14,11.4Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#7679b4"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M255.37,494.09l-1.26,6.84-12.22,8.55s-1.1-.94-2.92-2.43l16.16-13.25Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M336,587.33q-.84-.41-1.7-.87l-1.49-1.9-19.68-25V560c-.13,4.15-1.55,37.25-12.61,40.3-11.81,3.26-26.07,4.07-32.58-17.92s-18.33-70.05-30.55-72.9l18.12-14.87s12,14,16.9,27.48c-.18-.86-8.47-39.57-1.63-46.41h59.46s9.16,26.14,15.48,39.1c4.9,10.06,12.25,33.84,17,49.93C367.42,580.63,351,594.63,336,587.33Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#7679b4"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M334.34,483c-9.17,5.43-49.49,3.22-62.63,2.34l-3.57-.26c-.39,0,.06-.22.06-.22l.37-3.7,9.77-24.84L330.68,426c-1.06,3.19-1.42,8.08-1.33,13.69C329.61,457.67,334.34,483,334.34,483Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M334.34,481.79c-9.17,5.43-49.49,3.22-62.63,2.34l-3.57-.26-.59,0,.65-.17,3.22-.85,6.92-27.7,52.34-30.34c-1.06,3.19-1.42,8.08-1.33,13.69C329.61,456.45,334.34,481.79,334.34,481.79Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#f2f1f2"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M329.35,438.46c-10.64,2.45-34.06,9.66-43.06,27-6,11.58-11,16.55-14.57,18.63l-3.57-.26.06-.22,3.22-.85,6.92-27.7,52.34-30.34C329.61,428,329.26,432.85,329.35,438.46Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M148.21,447.17l12.22,7.33c-1.23.31-2.79,1.49-4.54,3.21-1-3-7.42-7.12-10.32-8.88C147.15,447.75,148.21,447.17,148.21,447.17Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M266,484.34a.73.73,0,0,1-.86-.11A2.94,2.94,0,0,0,266,484.34Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M293.61,361.23s-11,1.22-18.74-6.92c0,0-32.58,9.37-43.58,30.55s-85.94,62.72-85.94,62.72,13,7.33,11.81,11l49.28-28.51s17.51-12.63,22.4-15.48,31.77-20.36,37.47,27.29,0,42,0,42,8.15,2.85,20-20,48.47-28.1,48.47-28.1l2-24s7.27-15.92,1.7-22.56a14.1,14.1,0,0,1-3.26-6.89c-.93-6.1,0-16.27,13-24.72,20-13,27.7-23.62,27.7-23.62s.41-7.74-11.81-11.4-61.91-23.62-61.91-23.62l-1.63,6.92,39.1,27.7s-19.55,15.88-35,15.48C304.61,349,307.46,360.82,293.61,361.23Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#565388"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M301.16,342.26a80,80,0,0,1-2.25-10L277.32,338a23.8,23.8,0,0,1-.49,12.45,23.22,23.22,0,0,0,24.33-8.2Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref62 = /*#__PURE__*/React.createElement("circle", {
  cx: 158.13,
  cy: 207.57,
  r: 23.22,
  fill: "#ffbdc6"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M295.57,274c6.44.73,12.57,3.5,18.91,5a9.34,9.34,0,0,0,4.89.19c2.46-.76,4.46-3.34,7-3.26,1.57,0,3,1.12,4.26,2.15a51.11,51.11,0,0,1,5.87,5.21c4.37,4.75,7.09,11.15,11.08,16.31s10.28,9.18,15.95,6.81c-3.85,15-16.49,26.47-30.15,27.4-5.45.37-11-.76-16.31.84a14.28,14.28,0,0,1-4.12,1c-3,0-5.48-2.79-7.38-5.5-4.44-6.38-8-13.62-13-19.43-1.65-1.92-3.6-3.75-5.93-4.1s-4.48.76-6.56,1.84c-3.43,1.78-6.94,3.62-9.6,6.66s-4.34,7.59-3.24,11.71c.59,2.22,1.95,4.22,2,6.55,0,3.7-3.22,6.41-3.87,10a38.6,38.6,0,0,0-.16,4.56c-.29,4.94-3.51,9-6.89,12.09-1.31,1.21-2.77,2.5-3.15,4.37-.26,1.27,0,2.62-.17,3.91-.49,3.21-3.69,4.83-6.52,5.25a18.9,18.9,0,0,1-9.78-1.16c4-1.87,6.39-7.2,5.47-12-1.26-6.61-7.9-11.35-7.34-18.09a20.93,20.93,0,0,1,1.84-5.95,54.45,54.45,0,0,0,3.14-11.28,19.11,19.11,0,0,0-.19-9c-.85-2.59-2.58-4.65-4.06-6.84a38.82,38.82,0,0,1-4.7-9.63,6.75,6.75,0,0,1-.45-3.18,6.59,6.59,0,0,1,2-3.3c3.64-3.81,7.54-7.78,12.38-8.88a27.76,27.76,0,0,1,7-.27,82.24,82.24,0,0,0,12.21-.52c3.34-.39,9-.34,11.82-2.52,2.63-2,4.12-4.55,7.37-5.83A21.57,21.57,0,0,1,295.57,274Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M308.48,513.76s13.44,26.47,9.37,34.62",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M332.85,584.56l-19.68-25V560s-1.14-8.08,2.61-5.36c8.21,5.94,21.35,15.68,21.63,17.36S334.75,580.42,332.85,584.56Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref66 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M305,349s1.66,6.88-3.71,10.32c8.27-1.42,8.63-7.85,8.38-10.65A26.06,26.06,0,0,1,305,349Z",
  transform: "translate(-125.1 -119.24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M150.25,445.95s74.94-41.54,85.94-62.72c7.89-15.2,26.9-24.31,37-28.25-7.37,2.47-32.17,11.94-41.49,29.88-11,21.18-85.94,62.72-85.94,62.72Z",
  transform: "translate(-125.1 -119.24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M319.58,345.77c12.75-4,24.94-13.87,24.94-13.87l-39.1-27.7.89-3.8-3.74-1.5-1.63,6.92,39.1,27.7A94.35,94.35,0,0,1,319.58,345.77Z",
  transform: "translate(-125.1 -119.24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M319.83,439.63a96.88,96.88,0,0,1,15.33-3.87l.07-.79A103.76,103.76,0,0,0,319.83,439.63Z",
  transform: "translate(-125.1 -119.24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M272.44,482.3h-.36a.73.73,0,0,1-.86-.11,3,3,0,0,0,.86.11c1.34-.78,3.35-6.86-.86-42.06-4.5-37.58-22.16-34.63-31.83-30.31,9.88-2.72,23.48-.37,27.35,31.94,4.21,35.2,2.2,41.29.86,42.06A9,9,0,0,0,272.44,482.3Z",
  transform: "translate(-125.1 -119.24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M267.6,483.94a3,3,0,0,1-.86-.11A.73.73,0,0,0,267.6,483.94Z",
  transform: "translate(-125.1 -119.24)"
}));

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M295.57,273.21c6.44.73,12.57,3.5,18.91,5a9.34,9.34,0,0,0,4.89.19c2.46-.76,4.46-3.34,7-3.26,1.57,0,3,1.12,4.26,2.15a51.11,51.11,0,0,1,5.87,5.21c4.37,4.75,7.09,11.15,11.08,16.31s10.28,9.18,15.95,6.81c-3.85,15-16.49,26.47-30.15,27.4-5.45.37-11-.76-16.31.84a14.28,14.28,0,0,1-4.12,1c-3,0-5.48-2.79-7.38-5.5-4.44-6.38-8-13.62-13-19.43-1.65-1.92-3.6-3.75-5.93-4.1s-4.48.76-6.56,1.84c-3.43,1.78-6.94,3.62-9.6,6.66s-4.34,7.59-3.24,11.71c.59,2.22,1.95,4.22,2,6.55,0,3.7-3.22,6.41-3.87,10a38.6,38.6,0,0,0-.16,4.56c-.29,4.94-3.51,9-6.89,12.09-1.31,1.21-2.77,2.5-3.15,4.37-.26,1.27,0,2.62-.17,3.91-.49,3.21-3.69,4.83-6.52,5.25a18.9,18.9,0,0,1-9.78-1.16c4-1.87,6.39-7.2,5.47-12-1.26-6.61-7.9-11.35-7.34-18.09a20.93,20.93,0,0,1,1.84-5.95,54.45,54.45,0,0,0,3.14-11.28,19.11,19.11,0,0,0-.19-9c-.85-2.59-2.58-4.65-4.06-6.84a38.82,38.82,0,0,1-4.7-9.63,6.75,6.75,0,0,1-.45-3.18,6.59,6.59,0,0,1,2-3.3c3.64-3.81,7.54-7.78,12.38-8.88a27.76,27.76,0,0,1,7-.27,82.24,82.24,0,0,0,12.21-.52c3.34-.39,9-.34,11.82-2.52,2.63-2,4.12-4.55,7.37-5.83A21.57,21.57,0,0,1,295.57,273.21Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#a66477"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M958.6,221.09h0c0-.13,0-.25,0-.37s0-.26-.06-.38h-.16c0-.27,0-.54,0-.83-.4-9.27-13.22-29-18.36-23.24-4.5,5.06,2.29,17.86,5.75,23.62l.31.52-.17-.11s-14.31,42.68-16,44.34-13.47,35.22-29,39c-3.07.73-5.62,1.39-7.76,2l.17-.57c1-3.27,2.23-6.36,2.73-10s0-8.05-1.84-9.82c-.9-.88-2-1-2.74-2.4a11.08,11.08,0,0,1-.76-3.85l-1.32-16.18.92-.28c5.56-1.78,10.95-6,11.58-11.68a6,6,0,0,1-.59.19,10.13,10.13,0,0,0,.17-1c-4.67,1.84-9-3-13.5-5.17-7.41-3.63-15.88-.21-23.53.62-8.67.95-16.9-2.65-25.76-2-4.82.37-10.18,3.64-9.92,8.39.15,2.61,2,4.82,2.76,7.32,1.92,6.05-2.35,12.12-6.09,17.28-2.46,3.39-4.82,7.52-5.24,11.5-8.61-9-17.92-19.4-19-23.31L776.28,222s-.59.63-1.54,1.56c-.15-.46-.33-1-.53-1.54-3.18-8.91-12.18-30.5-23.59-26.54s4.73,26.09,11.75,34.91l1,1.22a3.16,3.16,0,0,1-1.78-.08l27.78,47.65s5.05,9.12,9.68,11.6c0,0,34.51,43.51,34.93,52.21S849.5,374.9,849.5,374.9s5.05,37.71-3.79,44.34h.11l.07,0H846l.1,0,.2,0,.13,0,.13,0,.17,0,.14,0,.2,0,.1,0c-.42.41-.85.86-1.29,1.35-6.55,7.26-14.92,22.82-3.48,49.28,16.83,39,19.36,54.28,19.36,54.28s-32,1.66-38.3,2.9c-5.58,1.1-27.27,1.87-32.23,2-1.77-2.06-7-6.62-14.06,0-8.84,8.29-15.15,36-15.15,36s-3.37,22.38,8,16.57c0,0,13.47-18.65,17.25-19.48,1.88-.41,3.87-3.18,5.39-5.85l.08.05h0c.09,0,.46-.2,1.06-.44h0c2.8-1.11,10.51-3.78,16.59-2.45,3.33.73,17.61.9,32.58.86-3.38,8.1-9.44,29-9.44,29S831,602.8,839.4,602c6-.59,15.2-15.92,20-24.67,3.48-2.55,13.45-11.69,20.82-11l49.66-19.06s11.78-6.63,5.47-28.59c-5-17.46-19.23-53.2-24.85-67.13h0l-.17-.36c-1.36-3.37-2.18-5.37-2.18-5.37h0a82.19,82.19,0,0,1-4.51-19.71c-.05-.53-.09-1.07-.13-1.6a8.84,8.84,0,0,0,1.95-1.13s-4.63-46.82,0-51.8l0,0h0l.08-.09v0l0-.06h0l.08-.1h0l.18-.23h0l.22-.28,0,0c.25-.33.55-.74.89-1.24h0c2.65-3.88,7.59-12.74,6.17-23.2v0q-.09-.68-.22-1.37h0a28.57,28.57,0,0,0-2.88-8.12,22.52,22.52,0,0,1-.37-3.21c0-.61,0-1.28,0-2v-.12q0-.29,0-.58v-.14c0-.47.08-1,.15-1.44l0-.18q0-.27.09-.55l0-.23c0-.18.08-.36.12-.54l0-.19c.06-.24.12-.48.2-.72l0-.12q.09-.3.2-.59l.09-.23.2-.48.1-.24c.08-.18.17-.36.26-.54l.07-.15q.18-.33.38-.65l.11-.17.33-.47.16-.21.35-.42.16-.18c.18-.19.36-.38.56-.56,5.47-5,29.88-41.85,29.88-41.85s5.89-8.29,5.89-13.67C949.24,266.34,959.65,231.64,958.6,221.09ZM893.07,530.84c-.6-5.68-1.2-12.72-1.75-20l9.52,14.84S899.94,530.2,893.07,530.84Z",
  transform: "translate(-125.1 -119.24)",
  fill: "url(#2bd42fb4-2e8b-436b-a616-1dc6bfdc374d)"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M793.81,527.7s-5.7-9-14.26-.81-14.66,35.43-14.66,35.43-3.26,22,7.74,16.29c0,0,13-18.33,16.7-19.14s7.74-11,7.74-11Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#493545"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M854.9,549.69s-7.74-3.67-10.18-.81-10.59,31.36-10.59,31.36-2.44,18.74,5.7,17.92S862.23,568,862.23,568Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#493545"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M854.9,549.69s-7.74-3.67-10.18-.81-10.59,31.36-10.59,31.36-2.44,18.74,5.7,17.92S862.23,568,862.23,568Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.05
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M881.78,494.3l17.51,27.29s-1.22,6.11-11.81,4.89l-36.25,22.81s-3.15,27.77,6.92,25.25c1.63-.41,13-12.22,21.18-11.4L927.4,544.4s11.4-6.52,5.29-28.1-26.31-71.62-26.31-71.62l-31.93,17.86Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#3e3d77"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M881.78,494.3l17.51,27.29s-1.22,6.11-11.81,4.89l-36.25,22.81s-3.15,27.77,6.92,25.25c1.63-.41,13-12.22,21.18-11.4L927.4,544.4s11.4-6.52,5.29-28.1-26.31-71.62-26.31-71.62l-31.93,17.86Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.05
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M892.78,534.62c2.44,15.48-11.4,16.7-11.4,16.7s-62.32,1.22-69.65-.41-17.11,2.85-17.11,2.85c-12.63-7.74-2.44-26.88-2.44-26.88s26.07-.81,32.18-2S861.42,522,861.42,522s-2.44-15.07-18.74-53.35c-11.07-26-3-41.3,3.37-48.43a26.82,26.82,0,0,1,5.59-4.92l50.1,2.44a65,65,0,0,0,.28,7.57,80.62,80.62,0,0,0,6.65,25c-2.85,0-21.18,17.11-21.18,17.11S890.33,519.15,892.78,534.62Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#3e3d77"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M795.84,528.51s26.07-.81,32.18-2,37.06-2.85,37.06-2.85-2.44-15.07-18.74-53.35c-11.07-26-3-41.3,3.37-48.43a26.82,26.82,0,0,1,5.59-4.92l46.42,2.26c0-.48,0-1,0-1.45l-50.1-2.44a26.82,26.82,0,0,0-5.59,4.92c-6.34,7.14-14.44,22.43-3.37,48.43C859,506.93,861.42,522,861.42,522s-31,1.63-37.06,2.85-32.18,2-32.18,2S782,546,794.62,553.77c0,0,.38-.18,1-.44C787.23,544.7,795.84,528.51,795.84,528.51Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref76 = /*#__PURE__*/React.createElement("rect", {
  x: 720.02,
  y: 146.57,
  width: 25.25,
  height: 63.94,
  fill: "#493545"
});

var _ref77 = /*#__PURE__*/React.createElement("rect", {
  x: 720.02,
  y: 146.57,
  width: 25.25,
  height: 63.94,
  opacity: 0.1
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M884.81,256.43c.87.24,1.85.27,2.44,1.47a9,9,0,0,1,.59,3l1.59,19.76a11,11,0,0,0,.74,3.78c.67,1.34,1.78,1.5,2.65,2.36,1.75,1.74,2.26,6.1,1.78,9.65s-1.69,6.59-2.64,9.8c-1.36,4.6-2.26,9.77-4.17,13.65s-5.38,6-7.62,2.74-1.94-9.84-2.36-15.23c-.7-9-4.21-16.76-4.45-25.82-.2-7.33,1.77-14.17,3-21.12.88-4.77.93-10.56,2.21-14.85C879.64,250.72,881.68,255.57,884.81,256.43Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#493545"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M884.81,256.43c.87.24,1.85.27,2.44,1.47a9,9,0,0,1,.59,3l1.59,19.76a11,11,0,0,0,.74,3.78c.67,1.34,1.78,1.5,2.65,2.36,1.75,1.74,2.26,6.1,1.78,9.65s-1.69,6.59-2.64,9.8c-1.36,4.6-2.26,9.77-4.17,13.65s-5.38,6-7.62,2.74-1.94-9.84-2.36-15.23c-.7-9-4.21-16.76-4.45-25.82-.2-7.33,1.77-14.17,3-21.12.88-4.77.93-10.56,2.21-14.85C879.64,250.72,881.68,255.57,884.81,256.43Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M777.92,228.34l-9.77,8.15s-1.16-1.36-2.89-3.56c-6.79-8.67-22.4-30.42-11.37-34.31s19.75,17.32,22.83,26.08C777.5,226.92,777.92,228.34,777.92,228.34Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#c77485"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M954.28,225.49c-4.07,6.11-9.77,0-9.77,0s-.73-1.09-1.76-2.85c-3.35-5.67-9.92-18.24-5.57-23.22,5-5.69,17.39,13.73,17.77,22.84A5.42,5.42,0,0,1,954.28,225.49Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#c77485"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M854.08,291.47s8.15,26.07,5.7,33.8S877.3,342,877.3,342h22.81s8.15-16.7,6.11-21.59-19.55-8.55-19.55-8.55-10.18,0-9.77-27.29Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#c77485"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M777.92,228.34l-9.77,8.15s-1.16-1.36-2.89-3.56c3.55-.63,9.06-5.81,11.47-8.23C777.5,226.92,777.92,228.34,777.92,228.34Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M954.28,225.49c-4.07,6.11-9.77,0-9.77,0s-.73-1.09-1.76-2.85l.13-.41c2.64,1.89,10.85.28,12.07,0A5.42,5.42,0,0,1,954.28,225.49Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M902,425.3c-12.6,5.75-53.54-4.49-56-5.1a26.82,26.82,0,0,1,5.59-4.92l50.1,2.44A65,65,0,0,0,902,425.3Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M859.38,313.87s-9.77,3.26-23.62-9.37c0,0-31-30.55-33-37.88l-24-42s-10.18,11-14.26,9.37l26.88,46.84s4.89,9,9.37,11.4c0,0,33.4,42.77,33.8,51.32S849.6,375,849.6,375s4.89,37.06-3.67,43.58c0,0,47.65,12.22,57.83,4.07,0,0-4.48-46,0-50.91,0,0,13.85-16.29,4.48-34.21,0,0-2-9.77,3.26-14.66s28.92-41.14,28.92-41.14,5.7-8.15,5.7-13.44c0,0,10.59-35.84,9-45.21,0,0-9.37,2-12.22,0,0,0-13.85,42-15.48,43.58s-13,34.62-28.1,38.29-17.51,5.29-17.51,5.29,29.32,18.33,15.07,26.47S859.38,313.87,859.38,313.87Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffaac4"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M877.89,297.74a77.83,77.83,0,0,1-.59-11.57l-22.81,6.92a30.76,30.76,0,0,1,1.43,4.68c2.61,1.15,6.13,3.87,9.16,3.87A20.77,20.77,0,0,0,877.89,297.74Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref88 = /*#__PURE__*/React.createElement("circle", {
  cx: 739.57,
  cy: 160.01,
  r: 21.18,
  fill: "#c77485"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M839.47,246.62c-4.66.36-9.86,3.58-9.6,8.25.14,2.57,1.9,4.74,2.67,7.2,1.85,5.95-2.27,11.92-5.89,17s-7,11.81-3.9,17.19a42.39,42.39,0,0,0,2.86,3.73c3.83,5.17,3.78,12.15,5.48,18.36a32.21,32.21,0,0,0,37.84,23,20.14,20.14,0,0,1-4.25-13.62c.23-3.56,1.38-7.28,0-10.57-1.78-4.23-7-5.9-9.69-9.6s-2.51-8.83-1.21-13.24,3.55-8.5,4.63-13a39.16,39.16,0,0,1,1-3.89c1.88-5.34,7.5-8.44,13-9.77s11.28-1.41,16.65-3.16,10.59-5.85,11.21-11.48c-4.52,1.81-8.71-2.91-13.07-5.08-7.18-3.56-15.37-.21-22.77.61C856,249.49,848,246,839.47,246.62Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M839.06,245.81c-4.66.36-9.86,3.58-9.6,8.25.14,2.57,1.9,4.74,2.67,7.2,1.85,5.95-2.27,11.92-5.89,17s-7,11.81-3.9,17.19a42.39,42.39,0,0,0,2.86,3.73c3.83,5.17,3.78,12.15,5.48,18.36a32.21,32.21,0,0,0,37.84,23,20.14,20.14,0,0,1-4.25-13.62c.23-3.56,1.38-7.28,0-10.57-1.78-4.23-7-5.9-9.69-9.6s-2.51-8.83-1.21-13.24,3.55-8.5,4.63-13a39.16,39.16,0,0,1,1-3.89c1.88-5.34,7.5-8.44,13-9.77s11.28-1.41,16.65-3.16,10.59-5.85,11.21-11.48c-4.52,1.81-8.71-2.91-13.07-5.08-7.18-3.56-15.37-.21-22.77.61C855.61,248.67,847.64,245.14,839.06,245.81Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#493545"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M885.65,326.3s8.48,7.57,10.15,10.91",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M904,371.51s-10.59,0-15.48,1.22-16.7,0-16.7,0",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref93 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M896.85,336.68a10.18,10.18,0,0,1-2.93,1.12,11.2,11.2,0,0,0,7.82-1.12c14.26-8.15-15.07-26.47-15.07-26.47h-4.89S911.11,328.54,896.85,336.68Z",
  transform: "translate(-125.1 -119.24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M955.19,223.79c0-.26-.06-.51-.1-.74a47.84,47.84,0,0,1-5.07.77A22.46,22.46,0,0,0,955.19,223.79Z",
  transform: "translate(-125.1 -119.24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M850.83,418.55c8.55-6.52,3.67-43.58,3.67-43.58s-14.66-22.81-15.07-31.36-33.8-51.32-33.8-51.32c-4.48-2.44-9.37-11.4-9.37-11.4s-27.7-45.21-31.77-46.84l26.88,46.84s4.89,9,9.37,11.4c0,0,33.4,42.77,33.8,51.32S849.6,375,849.6,375s4.89,37.06-3.67,43.58c0,0,29.29,7.51,46.85,6.83C875.18,424.79,850.83,418.55,850.83,418.55Z",
  transform: "translate(-125.1 -119.24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M859.62,314.19l-.24-.31a6.44,6.44,0,0,1-.85.19C858.91,314.12,859.27,314.16,859.62,314.19Z",
  transform: "translate(-125.1 -119.24)"
}));

var _ref94 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M955.09,223l-.25.05c-.43,12.51-9.11,41.9-9.11,41.9,0,5.29-5.7,13.44-5.7,13.44s-23.62,36.25-28.92,41.14-3.26,14.66-3.26,14.66l.05.1c-.16-3.29.24-8.39,3.61-11.51,5.29-4.89,28.92-41.14,28.92-41.14s5.7-8.15,5.7-13.44C946.13,268.26,956.72,232.42,955.09,223Z",
  transform: "translate(-125.1 -119.24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M903.37,368.45c.61,3.46.2-.2.41,3.26,0,0,10-11.73,7.27-26.23C911.87,358.44,903.37,368.45,903.37,368.45Z",
  transform: "translate(-125.1 -119.24)"
}));

var _ref95 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 469.79,
  cy: 620.44,
  rx: 427.67,
  ry: 41.08,
  fill: "#ffffff",
  opacity: 0.1
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M429.11,698s-14.56-49.45,2.73-85.84a78.1,78.1,0,0,0,6.32-49,131.35,131.35,0,0,0-6.94-23",
  transform: "translate(-125.1 -119.24)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M442,517.18c0,6.06-11,23.63-11,23.63s-11-17.57-11-23.63a11,11,0,1,1,21.94,0Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M460.11,550.74c-3.29,5.09-22.05,13.87-22.05,13.87s.34-20.71,3.63-25.8a11,11,0,1,1,18.42,11.93Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M459.32,608.11c-5.41,2.73-26,.84-26,.84s10.75-17.71,16.16-20.44a11,11,0,1,1,9.88,19.59Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M448.95,651.37c-4.87,3.6-25.53,5.23-25.53,5.23s7.6-19.27,12.48-22.88a11,11,0,0,1,13,17.64Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M415,565.79c4.35,4.22,24.6,8.6,24.6,8.6s-5-20.11-9.31-24.34A11,11,0,1,0,415,565.79Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M403.53,616.55c5.41,2.73,26,.84,26,.84S418.82,599.68,413.41,597a11,11,0,0,0-9.88,19.59Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M399.13,667.41c4.87,3.6,25.53,5.23,25.53,5.23s-7.6-19.27-12.48-22.88a11,11,0,1,0-13,17.64Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M442,517.18c0,6.06-11,23.63-11,23.63s-11-17.57-11-23.63a11,11,0,1,1,21.94,0Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff",
  opacity: 0.1
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M460.11,550.74c-3.29,5.09-22.05,13.87-22.05,13.87s.34-20.71,3.63-25.8a11,11,0,1,1,18.42,11.93Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff",
  opacity: 0.1
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M459.32,608.11c-5.41,2.73-26,.84-26,.84s10.75-17.71,16.16-20.44a11,11,0,1,1,9.88,19.59Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff",
  opacity: 0.1
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M448.95,651.37c-4.87,3.6-25.53,5.23-25.53,5.23s7.6-19.27,12.48-22.88a11,11,0,0,1,13,17.64Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff",
  opacity: 0.1
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M415,565.79c4.35,4.22,24.6,8.6,24.6,8.6s-5-20.11-9.31-24.34A11,11,0,1,0,415,565.79Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff",
  opacity: 0.1
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M403.53,616.55c5.41,2.73,26,.84,26,.84S418.82,599.68,413.41,597a11,11,0,0,0-9.88,19.59Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff",
  opacity: 0.1
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M399.13,667.41c4.87,3.6,25.53,5.23,25.53,5.23s-7.6-19.27-12.48-22.88a11,11,0,1,0-13,17.64Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff",
  opacity: 0.1
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M723.75,698.71s-14.56-49.45,2.73-85.84a78.1,78.1,0,0,0,6.32-49,131.35,131.35,0,0,0-6.94-23",
  transform: "translate(-125.1 -119.24)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M736.62,517.88c0,6.06-11,23.63-11,23.63s-11-17.57-11-23.63a11,11,0,0,1,21.94,0Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M754.76,551.44c-3.29,5.09-22.05,13.87-22.05,13.87s.34-20.71,3.63-25.8a11,11,0,1,1,18.42,11.93Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M754,608.81c-5.41,2.73-26,.84-26,.84s10.75-17.71,16.16-20.44A11,11,0,1,1,754,608.81Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M743.59,652.07c-4.87,3.6-25.53,5.23-25.53,5.23s7.6-19.27,12.48-22.88a11,11,0,0,1,13,17.64Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M709.66,566.49c4.35,4.22,24.6,8.6,24.6,8.6s-5-20.11-9.31-24.34a11,11,0,1,0-15.29,15.74Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M698.17,617.25c5.41,2.73,26,.84,26,.84s-10.75-17.71-16.16-20.44a11,11,0,0,0-9.88,19.59Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M693.78,668.11c4.87,3.6,25.53,5.23,25.53,5.23s-7.6-19.27-12.48-22.88a11,11,0,0,0-13,17.64Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M736.62,517.88c0,6.06-11,23.63-11,23.63s-11-17.57-11-23.63a11,11,0,0,1,21.94,0Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff",
  opacity: 0.1
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M754.76,551.44c-3.29,5.09-22.05,13.87-22.05,13.87s.34-20.71,3.63-25.8a11,11,0,1,1,18.42,11.93Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff",
  opacity: 0.1
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M754,608.81c-5.41,2.73-26,.84-26,.84s10.75-17.71,16.16-20.44A11,11,0,1,1,754,608.81Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff",
  opacity: 0.1
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  d: "M743.59,652.07c-4.87,3.6-25.53,5.23-25.53,5.23s7.6-19.27,12.48-22.88a11,11,0,0,1,13,17.64Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff",
  opacity: 0.1
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  d: "M709.66,566.49c4.35,4.22,24.6,8.6,24.6,8.6s-5-20.11-9.31-24.34a11,11,0,1,0-15.29,15.74Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff",
  opacity: 0.1
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  d: "M698.17,617.25c5.41,2.73,26,.84,26,.84s-10.75-17.71-16.16-20.44a11,11,0,0,0-9.88,19.59Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff",
  opacity: 0.1
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  d: "M693.78,668.11c4.87,3.6,25.53,5.23,25.53,5.23s-7.6-19.27-12.48-22.88a11,11,0,0,0-13,17.64Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff",
  opacity: 0.1
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  d: "M795,134.55h-6.28a4.4,4.4,0,1,0,0-8.79H737.8a4.4,4.4,0,0,0,0,8.79h6.28a4.4,4.4,0,0,0,0,8.79h-8.79a4.4,4.4,0,1,0,0,8.79h50.88a4.4,4.4,0,1,0,0-8.79H795a4.4,4.4,0,0,0,0-8.79Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#dee3f3",
  opacity: 0.5
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M500.78,160.19H496a3.35,3.35,0,1,0,0-6.69H457.28a3.35,3.35,0,0,0,0,6.69h4.78a3.35,3.35,0,1,0,0,6.69h-6.69a3.35,3.35,0,1,0,0,6.69h38.72a3.35,3.35,0,1,0,0-6.69h6.69a3.35,3.35,0,0,0,0-6.69Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#dee3f3",
  opacity: 0.5
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M175.78,634s17.5,34.35,3.24,53.14,1.3,70,1.3,70",
  transform: "translate(-125.1 -119.24)",
  fill: "none",
  stroke: "#ffffff",
  strokeMiterlimit: 10
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M181,623.26c0,6.62-4.86,12-4.86,12s-4.86-5.37-4.86-12,4.86-12,4.86-12S181,616.64,181,623.26Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  d: "M184.85,634s-17.5,34.35-3.24,53.14-1.3,70-1.3,70",
  transform: "translate(-125.1 -119.24)",
  fill: "none",
  stroke: "#ffffff",
  strokeMiterlimit: 10
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M179.67,623.26c0,6.62,4.86,12,4.86,12s4.86-5.37,4.86-12-4.86-12-4.86-12S179.67,616.64,179.67,623.26Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  d: "M179.67,623.26c0,6.62,4.86,12,4.86,12s4.86-5.37,4.86-12-4.86-12-4.86-12S179.67,616.64,179.67,623.26Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  d: "M192,634s17.5,34.35,3.24,53.14,1.3,70,1.3,70",
  transform: "translate(-125.1 -119.24)",
  fill: "none",
  stroke: "#ffffff",
  strokeMiterlimit: 10
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M197.17,623.26c0,6.62-4.86,12-4.86,12s-4.86-5.37-4.86-12,4.86-12,4.86-12S197.17,616.64,197.17,623.26Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  d: "M194.44,650.78c-4.59,4.77-11.82,5.27-11.82,5.27s.22-7.24,4.81-12,11.82-5.27,11.82-5.27S199,646,194.44,650.78Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  d: "M194.9,674.48c-4.59,4.77-11.82,5.27-11.82,5.27s.22-7.24,4.81-12,11.82-5.27,11.82-5.27S199.49,669.7,194.9,674.48Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  d: "M170,687.51c4.34,5,4.19,12.24,4.19,12.24s-7.19-.87-11.53-5.87-4.19-12.24-4.19-12.24S165.66,682.51,170,687.51Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  d: "M174,637c5.52,3.66,7.31,10.68,7.31,10.68s-7.16,1.09-12.68-2.57-7.31-10.68-7.31-10.68S168.51,633.32,174,637Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  d: "M174,637c5.52,3.66,7.31,10.68,7.31,10.68s-7.16,1.09-12.68-2.57-7.31-10.68-7.31-10.68S168.51,633.32,174,637Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  d: "M201.05,634s-17.5,34.35-3.24,53.14-1.3,70-1.3,70",
  transform: "translate(-125.1 -119.24)",
  fill: "none",
  stroke: "#ffffff",
  strokeMiterlimit: 10
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  d: "M195.87,623.26c0,6.62,4.86,12,4.86,12s4.86-5.37,4.86-12-4.86-12-4.86-12S195.87,616.64,195.87,623.26Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  d: "M195.87,623.26c0,6.62,4.86,12,4.86,12s4.86-5.37,4.86-12-4.86-12-4.86-12S195.87,616.64,195.87,623.26Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  d: "M197.27,651.29c-4.65,4.72-5,12-5,12s7.23-.41,11.88-5.13,5-12,5-12S201.92,646.57,197.27,651.29Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  d: "M197.27,651.29c-4.65,4.72-5,12-5,12s7.23-.41,11.88-5.13,5-12,5-12S201.92,646.57,197.27,651.29Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  d: "M206.38,684.1c-4.65,4.72-5,12-5,12s7.23-.41,11.88-5.13,5-12,5-12S211,679.38,206.38,684.1Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  d: "M193,676.89s10.53-16.6,25.32-17",
  transform: "translate(-125.1 -119.24)",
  fill: "none",
  stroke: "#ffffff",
  strokeMiterlimit: 10
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  d: "M184.77,666.86s-10.53-16.6-25.32-17",
  transform: "translate(-125.1 -119.24)",
  fill: "none",
  stroke: "#ffffff",
  strokeMiterlimit: 10
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  d: "M183.4,690.56s10.53-16.6,25.32-17",
  transform: "translate(-125.1 -119.24)",
  fill: "none",
  stroke: "#ffffff",
  strokeMiterlimit: 10
});

var _ref149 = /*#__PURE__*/React.createElement("circle", {
  cx: 92.71,
  cy: 540.56,
  r: 2.73,
  fill: "#ffffff"
});

var _ref150 = /*#__PURE__*/React.createElement("circle", {
  cx: 34.61,
  cy: 530.76,
  r: 2.73,
  fill: "#ffffff"
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  d: "M191.15,696s-10.53-16.6-25.32-17",
  transform: "translate(-125.1 -119.24)",
  fill: "none",
  stroke: "#ffffff",
  strokeMiterlimit: 10
});

var _ref152 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.99,
  cy: 559.92,
  r: 2.73,
  fill: "#ffffff"
});

var _ref153 = /*#__PURE__*/React.createElement("circle", {
  cx: 83.82,
  cy: 554.46,
  r: 2.73,
  fill: "#ffffff"
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  d: "M249.38,737.15S224,732.07,217.22,725.3,180,706.69,176.61,715.15s-45.69,37.23-16.92,42.31,67.69,6.77,76.15,3.38S249.38,737.15,249.38,737.15Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#a8a8a8"
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  d: "M159.69,754.31c28.77,5.08,67.69,6.77,76.15,3.38,6.44-2.58,10.92-15,12.69-20.72l.85.18s-5.08,20.31-13.54,23.69-47.38,1.69-76.15-3.38c-8.3-1.47-10.68-4.91-9.78-9.26C150.61,751,153.51,753.22,159.69,754.31Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.2
});

var _ref156 = /*#__PURE__*/React.createElement("path", {
  d: "M1019.93,641.78s8.38,11-3.87,27.5-22.35,30.51-18.26,40.83c0,0,18.48-30.73,33.52-31.16S1036.48,660.25,1019.93,641.78Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref157 = /*#__PURE__*/React.createElement("path", {
  d: "M1019.93,641.78a13.57,13.57,0,0,1,1.71,3.44c14.68,17.24,22.49,33.33,8.39,33.74-13.14.38-28.9,23.87-32.68,29.81a12.74,12.74,0,0,0,.45,1.35s18.48-30.73,33.52-31.16S1036.48,660.25,1019.93,641.78Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref158 = /*#__PURE__*/React.createElement("path", {
  d: "M1035.51,655.74c0,3.86-.43,7-1,7s-1-3.13-1-7,.54-2,1.07-2S1035.51,651.89,1035.51,655.74Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffd037"
});

var _ref159 = /*#__PURE__*/React.createElement("path", {
  d: "M1040.86,660.35c-3.39,1.85-6.34,3-6.59,2.49s2.28-2.35,5.67-4.19,2.05-.5,2.31,0S1044.24,658.5,1040.86,660.35Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffd037"
});

var _ref160 = /*#__PURE__*/React.createElement("path", {
  d: "M975.67,641.78s-8.38,11,3.87,27.5,22.35,30.51,18.26,40.83c0,0-18.48-30.73-33.52-31.16S959.12,660.25,975.67,641.78Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffffff"
});

var _ref161 = /*#__PURE__*/React.createElement("path", {
  d: "M975.67,641.78a13.57,13.57,0,0,0-1.71,3.44c-14.68,17.24-22.49,33.33-8.39,33.74,13.14.38,28.9,23.87,32.68,29.81a12.74,12.74,0,0,1-.45,1.35s-18.48-30.73-33.52-31.16S959.12,660.25,975.67,641.78Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.1
});

var _ref162 = /*#__PURE__*/React.createElement("path", {
  d: "M960.09,655.74c0,3.86.43,7,1,7s1-3.13,1-7-.54-2-1.07-2S960.09,651.89,960.09,655.74Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffd037"
});

var _ref163 = /*#__PURE__*/React.createElement("path", {
  d: "M954.74,660.35c3.39,1.85,6.34,3,6.59,2.49s-2.28-2.35-5.67-4.19-2.05-.5-2.31,0S951.35,658.5,954.74,660.35Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#ffd037"
});

var _ref164 = /*#__PURE__*/React.createElement("path", {
  d: "M962.76,708.67s23.43-.72,30.49-5.75,36-11,37.79-3,35.21,40.11,8.76,40.32-61.46-4.12-68.51-8.41S962.76,708.67,962.76,708.67Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#a8a8a8"
});

var _ref165 = /*#__PURE__*/React.createElement("path", {
  d: "M1040.27,737.47c-26.45.21-61.46-4.12-68.51-8.41-5.37-3.27-7.51-15-8.22-20.41l-.78,0s1.48,18.9,8.53,23.19,42.06,8.63,68.51,8.41c7.64-.06,10.27-2.78,10.13-6.8C1048.87,735.9,1046,737.42,1040.27,737.47Z",
  transform: "translate(-125.1 -119.24)",
  opacity: 0.2
});

var _ref166 = /*#__PURE__*/React.createElement("path", {
  d: "M302.94,193.88h-6.28a4.4,4.4,0,1,0,0-8.79H245.78a4.4,4.4,0,0,0,0,8.79h6.28a4.4,4.4,0,0,0,0,8.79h-8.79a4.4,4.4,0,0,0,0,8.79h50.88a4.4,4.4,0,1,0,0-8.79h8.79a4.4,4.4,0,0,0,0-8.79Z",
  transform: "translate(-125.1 -119.24)",
  fill: "#dee3f3",
  opacity: 0.5
});

var SvgWelcome = function SvgWelcome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "4ef1610a-9e03-48a5-8dcf-c01d7d13df94",
    "data-name": "Layer 1",
    width: 949.8,
    height: 661.52,
    viewBox: "0 0 949.8 661.52",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWelcome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/welcome.4c2cf223.svg";
export { ForwardRef as ReactComponent };